import axios from '../axios'
import MockAdapter from 'axios-mock-adapter'
import moment from 'moment'

const mockUsers = [
    {
        id: 1,
        username: 'admin',
        password: 'sqeAx7puyaAqtia',
        // avatar: 'https://raw.githubusercontent.com/taylorchen709/markdown-images/master/vueadmin/user.png',
        name: '张某某',
        auth: 20,
    }
];


function init() {
    console.log('mock init!')
    let mock = new MockAdapter(axios)
    mock.onPost('/api/login').reply(config =>{
        let {username, password} = JSON.parse(config.data)
        // console.log("data", config.data, username, password)
        return new Promise((resolve, reject) => {
            setTimeout(()=>{
                let user = null;
                let hasUser = mockUsers.some(u => {
                    if (u.username === username && u.password === password) {
                        user = JSON.parse(JSON.stringify(u));
                        user.password = undefined
                        return true
                    }
                })

                if (hasUser) {
                    resolve([200, user])
                } else {
                    resolve([500, '账户或密码错误'])
                }
            }, 500)
        })
    })
}

init()